module.exports = __webpack_public_path__ + "img/20190620162624837.72094ab8.png";